import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import {
	restoreDeletedElement,
	updateElementReorderConflictWithIncoming
} from '@editor2/services/conflictResolutionService';
import { getPageByElementId } from '@editor2/components/CourseChangesDiff/helpers';

export class ElementDeletedModifiedConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, incoming } = conflict;
		state.initialCourse.elements.entities[entityId] = incoming as any;
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, incoming } = conflict;
		restoreDeletedElement(state, entityId);

		state.elements.entities[entityId] = incoming as any;

		const initialParent = getPageByElementId(state.pages, entityId);
		updateElementReorderConflictWithIncoming(state, initialParent);
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
